import PersonalIdentity from "./PersonalIdentity";

export default PersonalIdentity;